import {HttpEventType} from '@angular/common/http';
import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ActivatedRoute} from '@angular/router';
import {from, Observable} from 'rxjs';
import {switchMap} from 'rxjs/operators';
import {Company} from 'src/app/model/company';
import {User} from 'src/app/model/user';
import {AuthService} from 'src/app/services/auth.service';
import {CompaniesService} from 'src/app/services/companies.service';

@Component({
  selector: 'aw-add-test-image',
  templateUrl: './add-test-image.component.html',
  styleUrls: ['./add-test-image.component.scss']
})
export class AddTestImageComponent implements OnInit {

  currentTestFile?: File;
  currentJsonInputFile?: File;
  currentJsonOutputSchemaFile?: File;

  progressTestFile = 0;
  progressJsonInputFile = 0;
  progressJsonOuputSchemaFile = 0;

  messageTestFile = '';
  messageJsonInputFile = '';
  messageJsonOutputSchemaFile = '';

  completeSubmission: any | null = null;
  finalSubmission: any | null = null;

  fileNameTest = 'Select File';
  fileNameJsonInputSchema = 'Select File';
  fileNameJsonOutputSchema = 'Select File';
  fileInfos?: Observable<any>;

  isTestFileUploaded: boolean = false;
  isJsonInputFileUploaded: boolean = false;
  isOutputSchemaFileUploaded: boolean = false;

  testCaseForm: FormGroup;
  scriptDescriptorForm: FormGroup;
  UN_R155_Options = ["Back-end servers used as a means to attack a vehicle or extract data (slt.001)", "Services from back-end server being disrupted, affecting the operation of a vehicle (slt.002)", "Vehicle related data held on back-end servers being lost or compromised ('data breach') (slt.003)", "Spoofing of messages or data received by the vehicle (slt.004)", "Communication channels used to conduct unauthorized manipulation, deletion or other amendments to vehicle held code/data (slt.005)", "Communication channels permit untrusted/unreliable messages to be accepted or are vulnerable to session hijacking/replay attacks (slt.006)", "Information can be readily disclosed. (slt.007)", "Denial of service attacks via communication channels to disrupt vehicle functions (slt.008)", "An unprivileged user is able to gain privileged access to vehicle systems (slt.009)", "Viruses embedded in communication media are able to infect vehicle systems  (slt.010)", "Messages received by the vehicle (for example X2V or diagnostic messages), or transmitted within it, contain malicious content (slt.011)", "Misuse or compromise of update procedures (slt.012)", "It is possible to deny legitimate updates (slt.013)", "Legitimate actors are able to take actions that would unwittingly facilitate a cyber-attack (slt.015)", "Manipulation of the connectivity of vehicle functions enables a cyber-attack (slt.016)", "Hosted 3rd party software (slt.017)", "Devices connected to external interfaces (slt.018)", "Extraction of vehicle data/code (slt.019)", "Manipulation of vehicle data/code (slt.020)", "Erasure of data/code (slt.021)", "Introduction of malware (slt.022)", "Introduction of new software or overwrite existing software (slt.023)", "Disruption of systems or operations (slt.024)", "Manipulation of vehicle parameters (slt.025)", "Cryptographic technologies can be compromised or are insufficiently applied (slt.026)", "Parts or supplies could be compromised to permit vehicles to be attacked (slt.027)", "Software or hardware development permits vulnerabilities (slt.028)", "Network design introduces vulnerabilities (slt.029)", "Physical loss of data loss (slt.030)", "Unintended transfer of data can occur (slt.031)", "Physical manipulation of systems can enable an attack (slt.032)"];
  GB_Options = ["Security test of system vulnerability (GB-7.1.1.1)",
    "Security test of network ports other than those required by service  (GB-7.1.1.2)",
    "Security test of verification of authenticity and integrity (GB-7.1.2.1)",
    "Security test of authority control of remote control instruction (GB-7.1.2.2)",
    "Security test of security log record (GB-7.1.2.3)",
    "Security test of integrity (GB-7.1.2.4)",
    "Security test of verification of authenticity and integrity (GB-7.1.3.1)",
    "Security test of access control (GB-7.1.3.2)",
    "Security test of access control of external interfaces (GB-7.1.4.1)",
    "Security test of access control of USB interface and SD card interface (GB-7.1.4.2)",
    "Security test of anti virus of USB (GB-7.1.4.3)",
    "Security test of identity authentication of diagnostic interfaces (GB-7.1.4.4)",
    "Security test of the authenticity of the identity of communication with cloud platform (GB-7.2.1)",
    "Security test of identification protection of denial of service attack (GB-7.2.10)",
    "Security test of identification of malicious data (GB-7.2.11)",
    "Security test of communication cybersecurity log (GB-7.2.12)",
    "Security test of identity authentication of V2X communication (GB-7.2.2)",
    "Security test of integrity of communication channels (GB-7.2.3)",
    "Security test against physical manipulation attacks (GB-7.2.7)",
    "Security test of prevention of unauthorized operation (GB-7.2.4)",
    "Security test of verifying the validity or uniqueness of the critical instruction data (GB-7.2.5)",
    "Security test of the confidentiality of the sensitive personal information (GB-7.2.6)",
    "Security test of prevention of unauthorized privileged access of components and parts for direct communication between the vehicle and the outside (GB-7.2.8)",
    "Security test of in vehicle security area isolation (GB-7.2.9)",
    "Security protection mechanism test (GB-7.3.1.1)",
    "Vulnerability security test (GB-7.3.1.2)",
    "Security test of identity authentication of server (GB-7.3.2.1)",
    "Security test of verification of authenticity and integrity of over the air update package (GB-7.3.2.2)",
    "Security test of over the air update cybersecurity event log (GB-7.3.2.3)",
    "Security test of offline update of update system with using on board software (GB-7.3.3.1)",
    "Security test of offline update of update system without using on board software (GB-7.3.3.2)",
    "Security test of prevention of unauthorized acquisition and access of the key (GB-7.4.1)",
    "Security test of prevention of disclosure of sensitive personal information (GB-7.4.2)",
    "Security test of prevention of unauthorized deletion and modification of sensitive personal information (GB-7.4.3)",
    "Security test of prevention of unauthorized deletion and modification of sensitive personal information (GB-7.4.4)",
    "Security test of prevention of modification and unauthorized deletion of log file (GB-7.4.5)",
    "Test method for personal information erasure function (GB-7.4.6)",
    "Test method for prevention of direct cross border data transfer (GB-7.4.7)",];
  RED_Options = ["Applicability of access control mechanisms (RED.ACM-1)",
    "Secure updates (RED.SUM-2)",
    "Appropriate access control mechanisms (RED.ACM-2)",
    "Applicability of authentication for network interfaces (RED.AUM-1-1)",
    "Applicability of authentication for user interfaces (RED.AUM-1-2)",
    "Appropriate authentication mechanisms (RED.AUM-2)",
    "Authenticator validation (RED.AUM-3)",
    "Changing authenticators (RED.AUM-4)",
    "Password strength (RED.AUM-5)",
    "Brute force protection (RED.AUM-6)",
    "Applicability of update mechanisms (RED.SUM-1)",
    "Automated updates (RED.SUM-3)",
    "Applicability of secure storage mechanisms (RED.SSM-1)",
    "Integrity protection for secure storage (RED.SSM-2)",
    "Confidentiality protection for secure storage (RED.SSM-3)",
    "Applicability of secure communication mechanisms (RED.SCM-1)",
    "Integrity and authenticity protection for communications (RED.SCM-2)",
    "Confidentiality protection for communications (RED.SCM-3)",
    "Replay protection for communications (RED.SCM-4)",
    "Resilience mechanisms (RED.RLM-1)",
    "Network monitoring mechanisms (RED.NMM-1)",
    "Traffic control mechanisms (RED.TCM-1)",
    "Appropriate confidential cryptographic keys (CCKs) (RED.CCK-1)",
    "CCK generation mechanisms (RED.CCK-2)",
    "Preventing static default pre-installed keys (RED.CCK-3)",
    "Up-to-date software and hardware (RED.GEC-1)",
    "Limit exposure of services (RED.GEC-2)",
    "Configuration of optional services (RED.GEC-3)",
    "Documentation of exposed interfaces and services (RED.GEC-4)",
    "No unnecessary external interfaces (RED.GEC-5)",
    "Input validation (RED.GEC-6)",
    "Best practice cryptography (RED.CRY-1)",];
  STRIDE_Options = ["spoofing", "tampering", "repudiation", "information disclosure", "denial of service", "elevation of privilege"];
  CIA_Options = ["confidentiality", "integrity", "availability"];
  isGBNASelected = false;
  isREDNASelected = false;
  REG_ID = /^(?<content>.*?)(?=\s*\((?<id>(?:slt\.\d+|gb-\d+(?:\.\d+)+|red\.[a-z]+-\d+(?:-\d+)*))\))/i;
  ///^(?<content>.*?)(?=\s*\((?<id>(?:(?:slt|SLT)\.\d+|(?:gb|GB)-\d+(?:\.\d+)+))\))/
  REG_TEST_FILE = /^(?<testId>[a-z0-9]+)_(?<scriptName>[a-z0-9]+)(?:_(?<schemaType>input|output)_schema\.json|\.tar)$/;


  isCIANASelected = false;
  isStrideNASelected = false;
  isUNR155NASelected = false;
  isNoDependeciesDefinedSelected = false;
  isNoDependeciesRequiredSelected = false;

  interfaces: string[] = [];
  targets: string[] = [];
  dependencies: string[] = [];
  testInformation: any[] = [];

  selectionTestInformation: any = null;

  company: Company;
  dependenciesForm = new FormControl<string[] | undefined>([]);

  loggedUser: User = this.authService.loggedUser();
  companyID: number;

  isTestFileUploading: boolean = false;
  isJsonInputFileUploading: boolean = false;
  isOutputSchemaUploading: boolean = false;

  isCreateNewTest: boolean | null =  null;


  constructor(
    private fb: FormBuilder,
    private companiesService: CompaniesService,
    private snackbar: MatSnackBar,
    private authService: AuthService,
    private route: ActivatedRoute
  ) {
    this.route.params.subscribe(params => {
      this.companyID = params['companyId'];
    })
  }

  ngOnInit(): void {

    // this.company = this.authService.loggedUser()?.company;
    this.companiesService.getCompanyById(this.companyID).subscribe(response => {
      this.company = response;

      this.companiesService.getSubmissionInformation(this.company.id).subscribe(response => {
        let res = response as any;
        this.interfaces = res.data.interfaces;
        this.targets = res.data.targetTypes;
        this.dependencies = res.data['dependency-list'];
        this.testInformation = res.data.testInformation;
      });

    });

    this.testCaseForm = this.fb.group({
      id: ['', Validators.required],
      title: ['', Validators.required],
      summary: ['', Validators.required],
      testObjectives: ['', Validators.required],
      examples: [''],
      subLevelThreatID: ['', Validators.required],/* UN R155 */
      gb: ['', Validators.required],
      red: ['', Validators.required],
      stride: ['', Validators.required],
      cia: ['', Validators.required],
      testSetup: ['', Validators.required],
      expectedResult: ['', Validators.required],
      claims: ['', Validators.required],
    });

    this.scriptDescriptorForm = this.fb.group({
      interface: ['', Validators.required],
      target: ['', Validators.required],
      scriptName: ['', Validators.required],
      version: ['', Validators.required],
      scriptDescription: ['', Validators.required]
    });

  }

  onSelectionUNR155Change(event: any) {
    const selectedValues = event.value;

    if (selectedValues.includes('N/A')) {
      this.isUNR155NASelected = true;
      this.testCaseForm.get('subLevelThreatID')?.setValue(['N/A']);
    } else {
      this.isUNR155NASelected = false;
      this.testCaseForm.get('subLevelThreatID')?.setValue(selectedValues);
    }
  }
  onSelectionGBChange(event: any) {
    const selectedValues = event.value;
    if (selectedValues.includes('N/A')) {
      this.isGBNASelected = true;
      this.testCaseForm.get('gb')?.setValue(['N/A']);
    } else {
      this.isGBNASelected = false;
      this.testCaseForm.get('gb')?.setValue(selectedValues);
    }
  }

  onSelectionREDChange(event: any) {
    const selectedValues = event.value;
    if (selectedValues.includes('N/A')) {
      this.isREDNASelected = true;
      this.testCaseForm.get('red')?.setValue(['N/A']);
    } else {
      this.isREDNASelected = false;
      this.testCaseForm.get('red')?.setValue(selectedValues);
    }
  }

  onSelectionStrideChange(event: any) {
    const selectedValues = event.value;

    if (selectedValues.includes('N/A')) {
      this.isStrideNASelected = true;
      this.testCaseForm.get('stride')?.setValue(['N/A']);
    } else {
      this.isStrideNASelected = false;
      this.testCaseForm.get('stride')?.setValue(selectedValues);
    }
  }

  onSelectionCIAChange(event: any) {
    const selectedValues = event.value;

    if (selectedValues.includes('N/A')) {
      this.isCIANASelected = true;
      this.testCaseForm.get('cia')?.setValue(['N/A']);
    } else {
      this.isCIANASelected = false;
      this.testCaseForm.get('cia')?.setValue(selectedValues);
    }
  }

  onSelectionTestCreationChange(event: any) {

    this.selectionTestInformation = event.value;

    if (this.selectionTestInformation === 'NEW') {
      this.isCreateNewTest = true;
      this.testCaseForm.get('id')?.setValidators([Validators.required]);
      this.testCaseForm.get('title')?.setValidators([Validators.required]);
      this.testCaseForm.get('summary')?.setValidators([Validators.required]);
      this.testCaseForm.get('testObjectives')?.setValidators([Validators.required]);
      this.testCaseForm.get('subLevelThreatID')?.setValidators([Validators.required]);
      this.testCaseForm.get('gb')?.setValidators([Validators.required]);
      this.testCaseForm.get('red')?.setValidators([Validators.required]); 
      this.testCaseForm.get('stride')?.setValidators([Validators.required]);
      this.testCaseForm.get('cia')?.setValidators([Validators.required]);
      this.testCaseForm.get('testSetup')?.setValidators([Validators.required]);
      this.testCaseForm.get('expectedResult')?.setValidators([Validators.required]);
      this.testCaseForm.get('claims')?.setValidators([Validators.required]);
    } else {
      this.isCreateNewTest = false;
      Object.keys(this.testCaseForm.controls).forEach(key => {
        this.testCaseForm.get(key)?.clearValidators();
      });
    }
      Object.keys(this.testCaseForm.controls).forEach(key => {
        this.testCaseForm.get(key)?.updateValueAndValidity();
      });
  }

  onSelectionDependeciesChange(event: any) {
    const selectedValues = event.value;

    if (selectedValues.includes('No dependencies required')) {
      this.isNoDependeciesRequiredSelected = true;
      this.isNoDependeciesDefinedSelected = false;
      this.dependenciesForm.setValue(['No dependencies required']);
    }
    else if (selectedValues.includes('No dependencies already defined')) {
      this.isNoDependeciesRequiredSelected = false;
      this.isNoDependeciesDefinedSelected = true;
      this.dependenciesForm.setValue(['No dependencies already defined']);
    }
    else {
      this.isNoDependeciesRequiredSelected = false;
      this.isNoDependeciesDefinedSelected = false;
      this.dependenciesForm.setValue(selectedValues);
    }

  }

  extractRegulationId(text: string): string | null {

    if (text === 'N/A')
      return 'N/A';

    return this.REG_ID.exec(text)?.groups?.id ?? null;
  }


  onFormSubmit() {

    let testInformation = null;

    if (this.isCreateNewTest)
      testInformation =  this.testCaseForm.value;
    else {
      testInformation = {
        id: this.selectionTestInformation,
      };
    }

    if (this.completeSubmission){
      this.completeSubmission = {
        ...this.completeSubmission,
        testInformation: testInformation,
        scriptDescriptor: {
          ...this.scriptDescriptorForm.value,
          userId: this.authService.loggedUser()?.id
        }
      }
    }
    else {
      this.completeSubmission = {
        testInformation: testInformation,
        scriptDescriptor: {
          ...this.scriptDescriptorForm.value,
          userId: this.authService.loggedUser()?.id
        }
      }
    }

  }

  onDependenciesSubmit() {
    this.completeSubmission = {
      ...this.completeSubmission,
      dependencies: this.dependenciesForm.value,
    }

  }

  finalSubmit() {
    if (this.isTestFileUploaded && this.isJsonInputFileUploaded && this.isOutputSchemaFileUploaded) {

      this.finalSubmission = this.completeSubmission;

      if (this.isCreateNewTest) {
        if (this.finalSubmission.testInformation.cia[0] === 'N/A')
          this.finalSubmission.testInformation.cia = [];
        if (this.finalSubmission.testInformation.subLevelThreatID[0] === 'N/A')
          this.finalSubmission.testInformation.subLevelThreatID = [];
        if (this.finalSubmission.testInformation.stride[0] === 'N/A')
          this.finalSubmission.testInformation.stride = [];
        if (this.finalSubmission.testInformation.gb?.[0] === 'N/A')
          this.finalSubmission.testInformation.gb = [];
        if (this.finalSubmission.testInformation.red?.[0] === 'N/A')
          this.finalSubmission.testInformation.red = [];
        } 
      const regulations = {
        annex5: (this.finalSubmission.testInformation.subLevelThreatID || []).map(item => 
          typeof item === 'string' ? item.toLowerCase() : item.id.toLowerCase()
        ),
        red: (this.finalSubmission.testInformation.red || []).map(item => 
          typeof item === 'string' ? item.toLowerCase() : item.id.toLowerCase()
        ),
        gb: (this.finalSubmission.testInformation.gb || []).map(item => 
          typeof item === 'string' ? item.toLowerCase() : item.id.toLowerCase()
        )
      };
      Object.keys(regulations).forEach(key => {
      if (regulations[key].length === 0) {
        regulations[key] = [];
      }
      });
      this.finalSubmission.testInformation.regulations = regulations;
      delete this.finalSubmission.testInformation.subLevelThreatID;
      delete this.finalSubmission.testInformation.gb;
      delete this.finalSubmission.testInformation.red;
      if (this.finalSubmission.dependencies[0] === 'No dependencies required')
        this.finalSubmission.dependencies = [];
      else if (this.finalSubmission.dependencies[0] === 'No dependencies already defined')
        this.finalSubmission.dependencies = "NOT_AVAILABLE";

      this.finalSubmission = [{...this.finalSubmission}];

      this.companiesService.addTestImage(this.company.id, this.finalSubmission).subscribe(respose => {
          this.snackbar.open("Test uploaded correctly!", 'Ok', {
            duration: 2000
          });
      }, error => {
          const error_message = error?.error?.message ||  error?.message ||  'Unknown error occurred';
          this.snackbar.open(`Upload failed: ${error_message}`, 'Ok', {
            duration: 6000
          });
      });
    }
  }


  selectTestImageFile(event: any): void {
    if (event.target.files && event.target.files[0]) {
      const file: File = event.target.files[0];
      if (file.type === 'application/x-tar') {
        this.currentTestFile = file;
        this.fileNameTest = this.currentTestFile.name;
      }
      else {
        this.snackbar.open("The extension is NOT correct!", 'Ok', {
          duration: 2000
        });
        event.target.value = ''; // reset
      }
    } else {
      this.fileNameTest = 'Select File';
    }
  }

  selectJsonInputImageFile(event: any): void {
    if (event.target.files && event.target.files[0]) {
      const file: File = event.target.files[0];
      if (file.type === 'application/json') {
        this.currentJsonInputFile = file;
        this.fileNameJsonInputSchema = this.currentJsonInputFile.name;
      }
      else {
        this.snackbar.open("The extension is NOT correct!", 'Ok', {
            duration: 2000
        });
        event.target.value = ''; // reset
      }
    } else {
      this.fileNameJsonInputSchema = 'Select File';
    }
  }

  selectOutputSchemaImageFile(event: any): void {
    if (event.target.files && event.target.files[0]) {
      const file: File = event.target.files[0];
      if (file.type === 'application/json') {
        this.currentJsonOutputSchemaFile = file;
        this.fileNameJsonOutputSchema = this.currentJsonOutputSchemaFile.name;
      }
      else {
        this.snackbar.open("The extension is NOT correct!", 'Ok', {
          duration: 2000
        });
        event.target.value = ''; // reset
      }
    } else {
      this.fileNameJsonOutputSchema = 'Select File';
    }
  }

  checkTestFileName(file: File): boolean {

    if (!file) return false;

    const match = file.name.match(this.REG_TEST_FILE);

    if (!match?.groups) {
      this.snackbar.open("The filename or the extension is NOT correct!", 'Ok', {
        duration: 2000
      });
      return false;
    }

    const { testId, scriptName, schemaType } = match.groups as {
      testId: string;
      scriptName: string;
      schemaType?: "input" | "output";
    };
    const underscoreCount = (file.name.match(/_/g) || []).length;
    if (schemaType) {
      if (underscoreCount !== 3) {
        this.snackbar.open("The filename or the extension is NOT correct!", 'Ok', {
          duration: 2000
        });
        return false;
      }
    }else {
      if (underscoreCount !== 1) {
        this.snackbar.open("The filename or the extension is NOT correct!", 'Ok', {
          duration: 2000
        });
        return false;
      }
    }
    // check if testId and scriptName of filename are the same of the form
    if (testId !== this.completeSubmission.testInformation.id ||
        scriptName !== this.completeSubmission.scriptDescriptor.scriptName) {
          this.snackbar.open("testId and scriptName in file name must be the same that you used to fill the form",  'Ok', {
            duration: 2000
          });
          return false;
        }

    return true
  }

  uploadTestFile() {


    if(this.currentTestFile) {

      let newFileName = this.completeSubmission.testInformation.id.toLowerCase() + "_" + this.completeSubmission.scriptDescriptor.scriptName.toLowerCase() + ".tar";

      let newCurrentTestFile = new File(
        [this.currentTestFile],
        newFileName,
        { type: this.currentTestFile.type }
      );

      this.companiesService.getUploadSignedUrl(this.company.id, newCurrentTestFile.name, newCurrentTestFile.size).subscribe(response => {

        let obs = new Observable<any>();
        obs = from(newCurrentTestFile.arrayBuffer()).pipe(
          switchMap( fileBuffer => {
            return this.companiesService.uploadFile(fileBuffer, newCurrentTestFile.name, newCurrentTestFile.type, response.data.url, response.data.fields)
          })
        );

        this.isTestFileUploading = true;

        obs.subscribe(event => {
          if (event.type === HttpEventType.UploadProgress)
            this.progressTestFile = Math.round(100 * event.loaded / event.total!);
          else if (event.type === HttpEventType.Response) {
            this.currentTestFile = null;
            this.snackbar.open('File Uploaded!', 'Close', {
              duration: 2000
            });
            this.isTestFileUploaded = true;
            this.isTestFileUploading = false;
          }

        }, error => {
          this.snackbar.open('File NOT Uploaded!', 'Close', {
            duration: 2000
          });
          this.isTestFileUploading = false;
        });

      });
    }

  }


  uploadJsonInputFile() {

    if(this.currentJsonInputFile) {

      let newFileName = this.completeSubmission.testInformation.id.toLowerCase() + "_" + this.completeSubmission.scriptDescriptor.scriptName.toLowerCase() + "_input_schema.json";

      let newJsonInputFile = new File(
        [this.currentJsonInputFile],
        newFileName,
        { type: this.currentJsonInputFile.type }
      );

      this.companiesService.getUploadSignedUrl(this.company.id, newJsonInputFile.name, newJsonInputFile.size).subscribe(response => {

        let obs = new Observable<any>();
        obs = from(newJsonInputFile.arrayBuffer()).pipe(
          switchMap( fileBuffer => {
            return this.companiesService.uploadFile(fileBuffer, newJsonInputFile.name, newJsonInputFile.type, response.data.url, response.data.fields)
          })
        );

        obs.subscribe(event => {
          if (event.type === HttpEventType.UploadProgress)
            this.progressJsonInputFile = Math.round(100 * event.loaded / event.total!);
          else if (event.type === HttpEventType.Response) {
            this.currentJsonInputFile = null;
            this.snackbar.open('File Uploaded!', 'Close', {
              duration: 2000
            });
            this.isJsonInputFileUploaded = true;
          }

        }, error => {
          this.snackbar.open('File NOT Uploaded!', 'Close', {
            duration: 2000
          });
        });

      });

    }

  }

  uploadOutputSchemaFile() {

    if(this.currentJsonOutputSchemaFile) {

      let newFileName = this.completeSubmission.testInformation.id.toLowerCase() + "_" + this.completeSubmission.scriptDescriptor.scriptName.toLowerCase() + "_output_schema.json";

      let newJsonOutputFile = new File(
        [this.currentJsonOutputSchemaFile],
        newFileName,
        { type: this.currentJsonOutputSchemaFile.type }
      );

      this.companiesService.getUploadSignedUrl(this.company.id, newJsonOutputFile.name, newJsonOutputFile.size).subscribe(response => {

        let obs = new Observable<any>();
        obs = from(newJsonOutputFile.arrayBuffer()).pipe(
          switchMap( fileBuffer => {
            return this.companiesService.uploadFile(fileBuffer, newJsonOutputFile.name, newJsonOutputFile.type, response.data.url, response.data.fields)
          })
        );

        obs.subscribe(event => {
          if (event.type === HttpEventType.UploadProgress)
            this.progressJsonOuputSchemaFile = Math.round(100 * event.loaded / event.total!);
          else if (event.type === HttpEventType.Response) {
            this.currentJsonOutputSchemaFile = null;
            this.snackbar.open('File Uploaded!', 'Close', {
              duration: 2000
            });
            this.isOutputSchemaFileUploaded = true;
          }

        }, error => {
          this.snackbar.open('File NOT Uploaded!', 'Close', {
            duration: 2000
          });
        });

      });

    }

  }
  
  resetTestFile(): void {
    this.currentTestFile = undefined;
    this.fileNameTest = 'Select File';
    this.progressTestFile = 0;
    this.messageTestFile = '';
    this.isTestFileUploaded = false;
    this.isTestFileUploading = false;
    // Reset the file input
    const fileInput = document.getElementById('testFileInput') as HTMLInputElement;
    if (fileInput) fileInput.value = '';
  }
  resetJsonInputFile(): void {
    this.currentJsonInputFile = undefined;
    this.fileNameJsonInputSchema = 'Select File';
    this.progressJsonInputFile = 0;
    this.messageJsonInputFile = '';
    this.isJsonInputFileUploaded = false;
    this.isJsonInputFileUploading = false;
    const fileInput = document.getElementById('jsonInputFileInput') as HTMLInputElement;
    if (fileInput) fileInput.value = '';
  }
  resetOutputSchemaFile(): void {
    this.currentJsonOutputSchemaFile = undefined;
    this.fileNameJsonOutputSchema = 'Select File';
    this.progressJsonOuputSchemaFile = 0;
    this.messageJsonOutputSchemaFile = '';
    this.isOutputSchemaFileUploaded = false;
    this.isOutputSchemaUploading = false;
    const fileInput = document.getElementById('outputSchemaFileInput') as HTMLInputElement;
    if (fileInput) fileInput.value = '';
  }
  sanitizeInput(event: Event, num: number): void {
    const input = event.target as HTMLInputElement;
    const sanitized = input.value.replace(/[\s_]/g, '');
    if (input.value !== sanitized) {
      input.value = sanitized;
      if (num === 1)
        this.testCaseForm.get('id')?.setValue(sanitized, { emitEvent: false });
      else if (num === 2)
        this.scriptDescriptorForm.get('scriptName')?.setValue(sanitized, { emitEvent: false });
      }
  }
  blockInvalidChars(event: KeyboardEvent): void {
    if (event.key === ' ' || event.key === '_') {
      event.preventDefault();
    }
  }

}
